/** "3:42 PM" today, "Sep 24, 3:42 PM" on any other day. */
export function formatSavedAt(value: Date | string, now: Date = new Date()): string {
  const date = typeof value === 'string' ? new Date(value) : value;
  if (Number.isNaN(date.getTime())) return '';
  const time = date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
  if (date.toDateString() === now.toDateString()) return time;
  const day = date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  return `${day}, ${time}`;
}

/** The one-line save state beside the Save button. */
export function saveStatusLabel(state: {
  isSaving: boolean;
  isDirty: boolean;
  hasConflict: boolean;
  lastSavedAt: Date | null;
}): string {
  if (state.hasConflict) return 'Not saved';
  if (state.isSaving) return 'Saving…';
  if (state.isDirty) return 'Unsaved changes';
  if (state.lastSavedAt) return `Saved ${formatSavedAt(state.lastSavedAt)}`;
  return 'All changes saved';
}
